<template>
  <v-form ref="notificationForm"
          :disabled="isFormDisabled()"
  >
    <v-row>
      <v-col cols="12" lg="5" xl="4">
        <v-text-field
            v-model="details.title"
            label="Tytuł"
            hint="Opcjonalny."
            :persistent-hint="true"
            counter="60"
        />
      </v-col>
      <v-col cols="12" lg="7" xl="8">
        <v-textarea
            v-model="details.body"
            :rules="rules.body"
            label="Treść"
            rows="2"
            placeholder=" "
            counter="500"
        ></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-slider
            v-model="details.delayInMinutes"
            :min="0"
            :max="2880"
            thumb-color="blue-grey"
            thumb-label="always"
            label="Opóźnienie"
            hint="Opóźnienie (w minutach) jakie musi wystąpić od momentu zakolejkowania tego powiadomienia."
            :persistent-hint="true"
        >
          <template v-slot:prepend>
            <v-icon
                @click="decrementDelayInMinutes"
            >
              mdi-minus
            </v-icon>
          </template>
          <template v-slot:append>
            <v-icon
                @click="incrementDelayInMinutes"
            >
              mdi-plus
            </v-icon>
            <v-text-field
                v-model="details.delayInMinutes"
                class="ml-3 mt-0 pt-0"
                hide-details
                single-line
                type="number"
                style="width: 60px"
            ></v-text-field>
          </template>
        </v-slider>
      </v-col>
      <v-col cols="12">
        <v-range-slider
            v-model="hours"
            min="0"
            max="23"
            thumb-color="blue-grey"
            thumb-label="always"
            hint="Przedział godzinowy, w jakim dozwolona jest wysyłka tego powiadomienia."
            :persistent-hint="true"
        />
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-text-field
            v-model="details.targetUrl"
            label="URL"
            hint="Na ten URL (pełny lub częściowy) zostanie przekierowany użytkownik po kliknięciu powiadomienia."
            :persistent-hint="true"
            counter="254"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h3>
          Urządzenia
        </h3>
      </v-col>
      <v-col>
        <v-tooltip
            :disabled="0 !== fbIdsAvailable"
            top
        >
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-checkbox
                  v-model="forMobile"
                  class="mt-0 d-inline-block mx-3"
                  label="Wyślij na urządzenia mobilne (Firebase)"
                  :hint="0 === fbIdsAvailable ? 'Nie mamy tokenu Firebase.' : ''"
                  :persistent-hint="true"
                  :hide-details="0 !== fbIdsAvailable"
                  :disabled="0 === fbIdsAvailable"
              />
            </span>
          </template>
          Nie mamy możliwości wysłania powiadomienia na urządzenia mobilne tego użytkownika, ponieważ nie mamy ani
          jednego tokenu Firebase. Być może ten użytkownik nie korzysta z aplikacji mobilnej lub tokeny Firebase
          zostały przypięte do innego konta (np. w trakcie przekształcania konta).
        </v-tooltip>
        <v-checkbox
            v-model="details.forWeb"
            label="Wyślij do przeglądarki (Mercure)"
            class="mt-0 d-inline-block mx-3"
            hide-details
        />
      </v-col>
    </v-row>
    <v-row v-if="canTargetUsersCriteriaBeDisplayed">
      <v-col cols="12 pb-0">
        <h3>
          Odbiorcy
        </h3>
      </v-col>
      <v-col class="d-flex flex-wrap">
        <v-card
            class="mx-3 blue-grey lighten-4 mb-3"
        >
          <v-card-title class="text-subtitle-1 pb-0">
            Konto
          </v-card-title>
          <v-card-text class="py-0">
            <v-checkbox
                v-model="targetUsersCriteria.registered"
                label="Zarejestrowane"
                class="d-inline-block mx-3"
            />
            <v-checkbox
                v-model="targetUsersCriteria.guests"
                label="Niezarejestrowane"
                class="d-inline-block mx-3"
            />
          </v-card-text>
        </v-card>
        <v-card
            class="mx-3 blue-grey lighten-4 mb-3"
        >
          <v-card-title class="text-subtitle-1 pb-0">
            Typ konta
          </v-card-title>
          <v-card-text class="py-0">
            <v-checkbox
                v-model="targetUsersCriteria.collectors"
                label="Zbierający odpady"
                class="d-inline-block mx-3"
            />
            <v-checkbox
                v-model="targetUsersCriteria.emitters"
                label="Wytwarzający odpady"
                class="d-inline-block mx-3"
            />
            <v-checkbox
                v-model="targetUsersCriteria.natural_persons"
                label="Osoby fizyczne"
                class="d-inline-block mx-3"
            />
          </v-card-text>
        </v-card>
        <v-card
            class="mx-3 blue-grey lighten-4 mb-3"
        >
          <v-card-title class="text-subtitle-1 pb-0">
            Inne
          </v-card-title>
          <v-card-text class="py-0">
            <v-checkbox
                v-model="targetUsersCriteria.having_sale_offers"
                label="Osoby, które wystawiły ofertę sprzedaży"
                class="d-inline-block mx-3"
            />
            <v-checkbox
                v-model="targetUsersCriteria.not_having_sale_offers"
                label="Osoby, które NIE wystawiły oferty sprzedaży"
                class="d-inline-block mx-3"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="isEditForm() && details.cancelledAt && details.cancelledAt.timestamp">
      <v-col cols="12">
        <h3>
          Status
        </h3>
      </v-col>
      <v-col>
        <v-text-field
          v-model="cancelledAtFormatted"
          label="Data anulowania"
          placeholder=" "
          readonly
        />
      </v-col>
      <v-col>
        <div v-if="details.cancelledAt && details.cancelledAt.timestamp"
             class="pb-2 disabled-label mb-2"
        >
          Anulował:
        </div>
        <router-link
            v-if="details.cancelledBy"
            :to="{name: 'user-details', params: { id: details.cancelledBy }}"
        >
          #{{ details.cancelledBy }}
        </router-link>
        <em v-if="details.cancelledAt && details.cancelledAt.timestamp && !details.cancelledBy">
          System
        </em>
      </v-col>
    </v-row>
    <v-row v-if="isEditForm()">
      <v-col cols="12">
        <h3>
          Paczka
        </h3>
      </v-col>
      <v-col>
        <v-text-field
            v-if="details.batchId"
            v-model="details.batchId"
            label="ID paczki"
            placeholder=" "
            readonly
        />
      </v-col>
      <v-col v-if="details.batchCancelledAt && details.batchCancelledAt.timestamp">
        <v-text-field
            v-model="cancelledAtFormatted"
            label="Data anulowania"
            placeholder=" "
            readonly
        />
      </v-col>
      <v-col>
        <v-btn
            v-if="details.batchId && (!details.batchCancelledAt || !details.batchCancelledAt.timestamp)"
            @click="cancelBatch"
        >
          Anuluj paczkę
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="error">
      <v-col cols="12">
        <v-alert
            dense
            outlined
            type="error"
        >
          {{ error }}
        </v-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 text-center">
        <v-btn
            v-if="!isEditForm()"
            class="mx-2"
            :disabled="loading"
            @click="add('')"
        >
          Dodaj
        </v-btn>
        <v-tooltip
            top
        >
          <template v-slot:activator="{ on }">
            <v-btn
                v-on="on"
                v-if="!isEditForm()"
                class="mx-2"
                :disabled="loading"
                @click="add('cancelled')"
            >
              Dodaj testowo
            </v-btn>
          </template>
          Spowoduje zakolejkowanie powiadomień, ale będą od razu anulowane, więc nie zostaną rozesłane do wskazanych
          odbiorców.
        </v-tooltip>
        <v-tooltip
            top
        >
          <template v-slot:activator="{ on }">
            <v-btn
                v-on="on"
                v-if="!isEditForm()"
                class="mx-2"
                :disabled="loading"
                @click="add('calculate')"
            >
              Policz odbiorców
            </v-btn>
          </template>
          Nie spowoduje zakolejkowania nowych powiadomień, lecz zwróci liczbę potencjalnych odbiorców
          spełniających wskazane kryteria.
        </v-tooltip>
        <div v-if="!isEditForm()" class="mt-4 mx-auto alert" style="max-width:615px">
          <v-alert
              dense
              border="top"
              colored-border
              type="info"
              elevation="2"
          >
            Nowe powiadomienia pojawią się na liście w ciągu kilku minut od dodania.
          </v-alert>
        </div>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import api from "@/services/api";
import errors from "@/mixins/errors";
import formatters from "@/mixins/formatters";

export default {
  props: {
    id: {
      type: [String],
      required: false,
      default: null,
    },
    targetUsers: {
      type: [Array],
      required: false,
      default: () => [],
    },
    fbIdsAvailable: {
      type: [Number],
      required: false,
      default: null,
    },
  },
  mixins: [
    errors,
    formatters,
  ],
  data() {
    return {
      default: {
        forAndroid: true,
        for_iOs: true,
        forWeb: true,
        delayInMinutes: 5,
        title: '',
        body: '',
        targetUrl: '',
      },
      defaultHours: [10, 18],
      defaultTargetUsersCriteria: {
        guests: false,
        registered: false,
        collectors: false,
        emitters: false,
        natural_persons: false,
        having_sale_offers: false,
        not_having_sale_offers: false,
      },
      details: {
        batchId: '',
        //forAndroid: true, // TODO.
        //for_iOs: true, // TODO.
        forWeb: true,
        delayInMinutes: 5,
        title: '',
        body: '',
        data: null,
        targetUrl: '',
        conditions: null,
        metadata: null,
        batchCancelledAt: null,
      },
      hours: [10, 18],
      forMobile: 0 !== this.fbIdsAvailable,
      targetUsersCriteria: {
        guests: false,
        registered: false,
        collectors: false,
        emitters: false,
        natural_persons: false,
        having_sale_offers: false,
        not_having_sale_offers: false,
      },
      label: {},
      rules: {
        body: [
          (value) => ('calculate' === this.selectedMode || !!value) || 'Wpisz treść wiadomości.',
        ],
      },
      selectedMode: '',
      loading: false,
      error: null,
    };
  },
  created() {
    if (this.id) {
      this.get();
    }
  },
  computed: {
    batchCancelledAtFormatted() {
      const ts = this.details.batchCancelledAt ? this.details.batchCancelledAt.timestamp : null

      if (!ts) {
        return ''
      }

      return this.localDateTime(ts)
    },
    canTargetUsersCriteriaBeDisplayed() {
      return !this.isEditForm() && !(this.targetUsers && this.targetUsers.length);
    },
    cancelledAtFormatted() {
      const ts = this.details.cancelledAt ? this.details.cancelledAt.timestamp : null

      if (!ts) {
        return ''
      }

      return this.localDateTime(ts)
    }
  },
  methods: {
    isFormDisabled() {
      return this.loading || this.isEditForm();
    },
    isEditForm() {
      return !!this.id;
    },
    get() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      api.get(`/api/notifications/${this.id}`)
          .then((response) => {
            const data = response.data;
            this.details = data;
            this.hours = [data.hourStart, data.hourStop];
            this.forMobile = data.forAndroid || data.for_iOs;
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się pobrać szczegółów.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    add(mode = '') {
      if (this.loading) {
        return;
      }

      this.selectedMode = mode;

      if (!this.$refs.notificationForm.validate()) {
        return;
      }

      this.error = null;

      if ((0 === this.fbIdsAvailable || !this.forMobile) && // Mobile not checked or not available.
          !this.details.forWeb
      ) {
        this.error = 'Wybierz przynajmniej jeden typ urządzeń.';

        return;
      }

      if (this.canTargetUsersCriteriaBeDisplayed &&
        !this.getTargetUsersCriteria().length
      ) {
        this.error = 'Wybierz przynajmniej jedną grupę odbiorców.';

        return;
      }

      this.loading = true;
      const self = this;
      let data = {
        targetUsers: this.targetUsers || [],
        targetUsersCriteria: [],
        forAndroid: this.forMobile, // TODO.
        for_iOS: this.forMobile, // TODO.
        forWeb: this.details.forWeb,
        delayInMinutes: this.details.delayInMinutes,
        hourStart: this.hours[0],
        hourStop: this.hours[1],
        title: this.details.title,
        body: this.details.body,
        targetUrl: this.details.targetUrl,
        mode: mode ? mode : undefined,
      };

      data.targetUsersCriteria = this.getTargetUsersCriteria();
      const calculationOnly = 'calculate' === mode;

      api.post('/api/notifications', data)
          .then((response) => {
            const total = response.data.total || 0;
            const type = (!total && 202 === response.status) ? 'notifyWarning' : 'notifySuccess';
            let message;

            if (calculationOnly) {
              message = `Liczba użytkowników spełniających wskazane kryteria: ${total}.`;
            } else if (total) {
              message = `Powiadomienia zostaną wkrótce zakolejkowane do następującej liczby użytkowników: ${total}.`;
            } else {
              message = `Brak użytkowników spełniających wskazane kryteria.`;
            }

            this.$root.$emit(type, {
              html: message,
              callback: () => {
                // The following setTimeout() call is required to render the success message for the user before
                // displaying the built-in prompt window.
                setTimeout(function () {
                  self.loading = false;

                  if (!calculationOnly) {
                    self.askForNext();
                  }
                }, 500);
              }
            });
          })
          .catch((error) => {
            this.loading = false;
            let message = calculationOnly
              ? 'Nie udało się policzyć użytkowników spełniających wskazane kryteria.'
              : 'Nie udało się zakolejkować powiadomienia.';
            const resolved = this.resolveException(error);

            if (resolved) {
              let messages = [];

              for (let key in resolved) {
                messages.push(resolved[key].message);
              }

              error = null;
              message = messages.join("\n");
            }

            this.$root.$emit('notifyError', {
              html: message,
              error,
            });
          });
    },
    cancelBatch() {
      if (this.loading) {
        return;
      }

      api.delete(`/api/notifications/batch/${this.details.batchId}`)
          .then((response) => {
            const batch = response.data.batch;

            if (batch.cancelledAt && batch.cancelledAt.timestamp) {
              this.$root.$emit('notifySuccess', {
                html: `Wysyłka tej paczki powiadomień została anulowana.`,
              });
            } else {
              this.$root.$emit('notifyError', {
                html: `Serwer przyjął żądanie, ale z nieznanej przyczyny nie anulował tej paczki.`,
              });
            }
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się anulować wysyłki tej paczki powiadomień.',
              error,
            });
          });
    },
    getTargetUsersCriteria() {
      let criteria = [];

      for (const [name, checked] of Object.entries(this.targetUsersCriteria)) {
        if (checked) {
          criteria.push(name);
        }
      }

      return criteria;
    },
    askForNext() {
      if (confirm('Chcesz zakolejkować kolejne powiadomienie?')) {
        this.clear();
      } else if (!this.targetUsers) {
        this.$router
            .push({name: 'notifications'})
            .catch(() => {
            });
      }
    },
    clear() {
      for (const [name, value] of Object.entries(this.default)) {
        this.details[name] = value;
      }

      for (const [name, checked] of Object.entries(this.defaultTargetUsersCriteria)) {
        this.targetUsersCriteria[name] = checked;
      }
    },
    decrementDelayInMinutes() {
      this.details.delayInMinutes--;
    },
    incrementDelayInMinutes() {
      this.details.delayInMinutes++;
    },
  },
}
</script>